import React, { createContext, useState, useCallback } from "react";
import { v4 as uuidv4 } from "uuid";
import SuccessPopup from "./SuccessPopup";
import ErrorPopup from "./ErrorPopup";

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    const showSuccess = useCallback((message, icon) => {
        setNotifications((prevNotifications) => [
            ...prevNotifications,
            { type: "success", message, icon, id: uuidv4() },
        ]);
    }, []);

    const showError = useCallback((message) => {
        setNotifications((prevNotifications) => [
            ...prevNotifications,
            { type: "error", message, id: uuidv4() },
        ]);
    }, []);

    const showWarning = useCallback((message) => {
        setNotifications((prevNotifications) => [
            ...prevNotifications,
            { type: "warning", message, id: uuidv4() },
        ]);
    }, []);

    const handleClose = useCallback((id) => {
        setNotifications((prevNotifications) =>
            prevNotifications.filter((notification) => notification.id !== id)
        );
    }, []);

    return (
        <NotificationContext.Provider value={{ showSuccess, showError, showWarning }}>
            {children}
            {notifications.map(({ type, message, icon, id }) => {
                if (type === "success") {
                    return (
                        <SuccessPopup
                            key={id}
                            open={true}
                            onClose={() => handleClose(id)}
                            message={message}
                            icon={icon}
                        />
                    );
                } else if (type === "error") {
                    return (
                        <ErrorPopup
                            key={id}
                            open={true}
                            onClose={() => handleClose(id)}
                            message={message}
                        />
                    );
                } else if (type === "warning") {
                    return (
                        <ErrorPopup
                            key={id}
                            open={true}
                            onClose={() => handleClose(id)}
                            message={message}
                            title="Warning"
                        />
                    )
                }
            })}
        </NotificationContext.Provider>
    );
};
